import { render, staticRenderFns } from "./valuable-concepts-modal-tree.vue?vue&type=template&id=64e537cc&scoped=true&"
import script from "./valuable-concepts-modal-tree.ts?vue&type=script&lang=ts&"
export * from "./valuable-concepts-modal-tree.ts?vue&type=script&lang=ts&"
import style0 from "./valuable-concepts-modal-tree.scss?vue&type=style&index=0&id=64e537cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e537cc",
  null
  
)

export default component.exports